/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EmailTemplateRestService, SmsTemplateRestService } from '@gh/builder-shared-data';
import { getRouteParam, InitViewService, isRouteForCreationMode } from '@gh/common-shared';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { newSmsTemplateDetails, SmsPlaceholder, SmsTemplateDetails } from './sms-templates.model';

@Injectable()
export class SmsTemplateDetailsBusinessService implements InitViewService {
  constructor(private smsTemplateRest: SmsTemplateRestService,
              private emailTemplateRest: EmailTemplateRestService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      details: isRouteForCreationMode(route)
        ? newSmsTemplateDetails()
        : this.smsTemplateRest.get(getRouteParam(route, 'templateId')),
    };
  }

  save(template: SmsTemplateDetails): Observable<SmsTemplateDetails> {
    if (template.id) {
      return this.smsTemplateRest.update(template);
    } else {
      return this.smsTemplateRest.create(template);
    }
  }

  findAllSmsPlaceholders(query: FilteredDataQuery<string>): Observable<SmsPlaceholder[]> {
    return this.emailTemplateRest.findAllPlaceholdersAsAutocompleteDataSource({ code: query.filter || '', sms: true })
      .select(query).pipe(
        map$(getSlicedData));
  }
}
